import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getLinkCustomerIcneaUrl } from "./api-url.constants";
import {
  LinkCustomerIcneaError,
  LinkCustomerIcneaInvalidOwnerError,
  LinkCustomerIcneaNotConfiguredError,
} from "./errors";

interface LinkCustomerIcneaBody {
  ownerId: string;
  clientPassword: string;
  userId?: string;
}

export const linkCustomerIcnea = async (body: LinkCustomerIcneaBody): Promise<void> => {
  const response = await typedFetch(getLinkCustomerIcneaUrl(body.userId), {
    method: API_METHODS.POST,
    body: JSON.stringify({
      ownerId: body.ownerId,
      clientPassword: body.clientPassword,
    }),
  });

  if (!response.ok) {
    if (response.status === 400) {
      throw new LinkCustomerIcneaInvalidOwnerError();
    } else if (response.status === 503) {
      throw new LinkCustomerIcneaNotConfiguredError();
    }
    throw new LinkCustomerIcneaError();
  }
};
